function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { EXPIRY_FORMAT_REGEX } from './creditCardConstants';
/*
 * Get expiration month based on input value.
 *
 * This is a Date object containing the first day of the month after the user's input,
 * as cards are not considered expired until then.
 *
 * @param  {string} value  A string in the format of M/YY or MM/YY.
 * @return  {Object}  The date to check current time against
 */

var _getExpirationDate = function _getExpirationDate(value) {
  var _value$split = value.split('/'),
      _value$split2 = _slicedToArray(_value$split, 2),
      monthAsMM = _value$split2[0],
      yearAsYY = _value$split2[1]; // Apologies when this breaks in 3000. Long live EB.


  var year = parseInt(yearAsYY, 10) + 2000;
  var nextMonth = parseInt(monthAsMM, 10); // JavaScript uses zero-based indexing for months (0 is January). We're not correcting for it
  // because a card is not considered expired until the month after the expiration date, so
  // being a month ahead is actually the correct behavior.

  return new Date(year, nextMonth, 1);
};
/*
 * Check whether the expiration date is in the past.
 *
 * @param  {Object} date  Date object containing the expiration date
 * @return  {Boolean}  Whether the card is expired
 */


var _isExpired = function _isExpired(date) {
  return date < new Date();
};
/*
 * Check whether the user has input a valid expiration date.
 *
 * This verifies the user's input is in the current format (after we've performed our own input
 * masking/manipulation), parses a date, and checks if it is in the past.
 *
 * @param  {string} value  A string in the format of M/YY or MM/YY
 * @return  {Boolean}  Whether the expiration date is valid
 */


export var isValidExpirationDate = function isValidExpirationDate(value) {
  if (!EXPIRY_FORMAT_REGEX.test(value)) {
    return false;
  }

  var expirationDate = _getExpirationDate(value);

  return !_isExpired(expirationDate);
};